import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { setLayout } from "./layout"; // 注入 hzero-front 时 注入 自定义的 layouts
// 左侧呼出菜单, Left-side callout menu

setLayout('leftSideCallout', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", import("../layouts/LeftSideCalloutLayout"));
        case 1:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}))); // 顶部及左侧固定菜单, Fixed Top Navigation & Fixed Left-Side Navigation

setLayout('horizontal', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", import("../layouts/TopLayout"));
        case 1:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2);
}))); // 左侧平铺菜单, Left-side tile menu

setLayout('side-all', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", import("../layouts/CommonLayout"));
        case 1:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3);
}))); // 顶部悬浮菜单, Top hover menu

setLayout('plane', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", import("../layouts/PlaneLayout"));
        case 1:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4);
}))); // 注入 hzero-front 时 注入 自定义的 layouts